import { z } from "zod";

import { castToCommaList, castToNumber, validateIdNotExponent } from "../utils";

export const TestProductInputStateList = ["price", "compareAtPrice"] as const;
export type TestProductInputStateType =
  (typeof TestProductInputStateList)[number];

export const FileBuildTestGroupStateSchema = z.object({
  name: z.string(),
  percentage: z.number(),
  order: z.number(),
});
export type FileBuildTestGroupStateType = z.infer<
  typeof FileBuildTestGroupStateSchema
>;

// Test Groups within Variants
export const ProductVariantEventStatusList = [
  "pending",
  "failed",
  "successful",
] as const;
export type ProductVariantEventStatus =
  | (typeof ProductVariantEventStatusList)[number]
  | null
  | undefined;

export const BuildFileTypesList = ["csv", "excel"] as const;
export type BuildFileTypes = (typeof BuildFileTypesList)[number];

export const AgProductSchema = z.object({
  productId: z.string(),
  productTitle: z.string(),
  productImage: z.string().nullish(),
  handle: z.string().nullish(),
  variantId: z.string(),
  variantTitle: z.string(),
  variantPrice: z.string(),
  requiresSellingPlan: z.boolean().optional(),
  variationPrices: z.record(
    z.string(),
    z.object({
      name: z.string(),
      variationId: z.string(),
      id: z.string(),
      price: z.string().nullish(),
      compareAtPrice: z.string().nullish(),
      ogPrice: z.string().nullish(),
      ogCompareAtPrice: z.string().nullish(),
    })
  ),
});
export type AgProductType = z.infer<typeof AgProductSchema>;

export const ProductTableWarningSchema = z.object({
  missingPrices: z.array(AgProductSchema),
  invalidPrices: z.array(AgProductSchema),
  personalizationIncreasedPrice: z.array(AgProductSchema),
});
export type ProductTableWarningType = z.infer<typeof ProductTableWarningSchema>;

export const CogsExcelSchema = z.object({
  productTitle: z.string().nullish().default(""),
  productId: validateIdNotExponent,
  variantTitle: z.string().nullish().default(""),
  variantId: validateIdNotExponent,
  sku: z.string().nullish().default(""),
  handle: z.string().nullish().default(""),
  inventory: z.coerce.number().nullish().default(0),
  tags: castToCommaList.nullish().default(""),
  productType: z.string().nullish().default(""),
  status: z.string().nullish().default(""), // z.enum(["ACTIVE", "DRAFT", "ARCHIVED"]),
  price: castToNumber,
  compareAtPrice: castToNumber.nullish(),
  cogs: castToNumber,
  shopifyDomain: z.string().nullish().default(""),
  updatedAtTs: z.coerce.number().nullish().default(0),
  productGroup: z.string().nullish().default(""),
});

export type CogsCsv = z.infer<typeof CogsExcelSchema>;
export type CogsExcelRow = z.infer<typeof CogsExcelSchema>;
